import Cat from './cat.js';
import Dog from './dog.js';
export { Dog, Cat };



// WEBPACK FOOTER //
// ./src/index.js